export enum UserKeys {
  adminGetAllStaff = "admin-get-all-staff",
  adminGetAllAdmins = "admin-get-all-admins",
  adminGetAUser = "admin-get-a-user",
  getAllVirtualStaff = "get-all-eteam-members",
  getAllStaffClients = "get-all-staff-clients",
  clientGetProfile = "client-get-profile",
  getAssessmentResult = "get-assessment-result",
}
